exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /usr/local/app/~/core-js/modules/_wks-ext.js
// module id = ../../../../core-js/modules/_wks-ext.js
// module chunks = 0